import {Textarea} from '@mantine/core';
import classNames from 'classnames';
import type {FC} from 'react';
import {MdSend} from 'react-icons/md';

export const InputFreeTextarea: FC<{
  textInput: string;
  editing: boolean;
  setTextInput: (value: string) => void;
  sendClick: () => void;
}> = ({textInput, setTextInput, sendClick}) => {
  return (
    <div>
      <div className="flex gap-16 max-w-3/4 pc:max-w-1/2 justify-end items-end">
        <Textarea
          autosize
          className="grow"
          styles={{
            input: {
              padding: 20,
            },
          }}
          value={textInput}
          placeholder="回答を入力してください"
          onChange={(e) => {
            setTextInput(e.currentTarget.value);
          }}
          radius="xl"
          onKeyDown={(e) => {
            if (
              (e.ctrlKey || e.metaKey) &&
              e.key === 'Enter' &&
              textInput !== ''
            ) {
              sendClick();
              e.preventDefault(); // デフォルトの動作を防ぐ
            }
          }}
        />
        <button
          onClick={sendClick}
          disabled={textInput === ''}
          className={classNames(
            'text-base flex items-center justify-center gap-4 p-8 h-full rounded-full pc:rounded-16 pc:px-32 pc:py-12',
            {
              'bg-gradient-to-r from-gradient-ai-l to-gradient-ai-r text-white  cursor-pointer hover:opacity-60':
                textInput !== '',
              'bg-black-5 text-black-2 cursor-not-allowed': textInput === '',
            },
          )}
        >
          <MdSend size={24} />
        </button>
      </div>
    </div>
  );
};
